import { JSX } from 'solid-js';
import { ChevronDownCviIcon } from '../../components/icons-library/chevron-down-cvi';

type Props = {
    heading: string;
    children: JSX.Element;
    initialOpen?: boolean;
};

/* DS `Accordion item`. Items are flush and separated by their own bottom divider, so
   stacking them forms the list — no gap or radius of their own.
   Native <details>, so the item toggles before hydration and find-in-page can reach
   closed content; the chevron follows the open state in CSS alone. */
export const Accordion = (props: Props) => {
    /* Read once, so a later prop change can't yank the panel out from under the reader
       — `initialOpen` seeds the element, the user owns it from there. */
    const initialOpen = props.initialOpen ?? false;

    return (
        <details
            class="group border-b border-cvi-border-default"
            open={initialOpen}
        >
            <summary class="focus-ring-cvi-flush flex cursor-pointer list-none items-start gap-cvi-5 px-cvi-4 py-cvi-6 text-cvi-fg-default [&::-webkit-details-marker]:hidden">
                <h2 class="heading-md font-cvi-medium m-0 min-w-0 flex-1 break-words pt-cvi-1">
                    {props.heading}
                </h2>
                <span class="inline-flex size-cvi-icon-box shrink-0 items-center justify-center transition-transform duration-300 motion-reduce:transition-none group-open:rotate-180">
                    <ChevronDownCviIcon size="lg" ariaHidden={true} />
                </span>
            </summary>
            <div class="px-cvi-4 pb-cvi-9 text-cvi-fg-muted">
                {props.children}
            </div>
        </details>
    );
};
